// OutlineLevel — Sprint 19BH Day 2 Step 2.2 · v4 manifest declarative field.
//
// v4-rewrite.md §6: each generated component declares which CurriculumOutline
// levels its `ItemTags` must reference. Audit rule `tag_in_outline` reads
// this list to know what to enforce per stage:
//   - `chapter` — every item must declare ≥1 caseId from outline.chapters
//   - `topic`   — items may (but need not) declare topicIds; non-empty arrays
//                 must reference outline topicIds
//   - `concept` — every item must declare ≥1 conceptId from outline.concepts
//
// Example per-stage configuration (Step 2.3 will populate the real MANIFEST):
//   mcq · ['chapter', 'topic', 'concept']    — pinpoint accuracy
//   glossary · ['chapter', 'concept']        — term ↔ concept (no topic)
//   reading_passage · ['chapter']            — long passage spans topics
import { z } from 'zod';
export const OUTLINE_LEVEL_VALUES = ['chapter', 'topic', 'concept'];
export const OutlineLevelSchema = z.enum(OUTLINE_LEVEL_VALUES);
//# sourceMappingURL=outline-level.js.map